const apiConfig = {
    baseUrl: '', // Server
    //baseUrl: 'https://localhost:7265', // Local
  };
  
  export default apiConfig;